import React from "react";

const NotFound = () => {
  return (
    <div className=" main p-5">
      <div className="text-center">
        <div className="row">
          <div className="col-13">
            <h1 className="text-danger">404 Not Found</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
